import PropTypes from 'prop-types';
import { memo } from 'react';
import { SmallProjectCard } from './SmallProjectCard.js';


export let SmallProjectList = function ({ projects, showGiveWidget, onProjectCardClick, altViewForFullyFundedProjects }) {
    const projectList = projects.map((project, index) =>
        <SmallProjectCard
            project={project}
            key={project.id}
            showGiveWidget={showGiveWidget}
            onProjectCardClick={onProjectCardClick}
            altViewForFullyFundedProjects={altViewForFullyFundedProjects}
        />,
    );

    return (
        <div className="fluid-container">
            {projectList}
        </div>
    );
};

SmallProjectList.propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object).isRequired,
    onProjectCardClick: PropTypes.func,
    showGiveWidget: PropTypes.bool,
};

SmallProjectList = memo(SmallProjectList);
